import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { createApp } from 'vue';
import Menu from './components/Menu';
import MenuBackground from './components/MenuBackground';
import Slider from './components/Slider';
import ResponsiveVideo from './components/ResponsiveVideo';
import VideoPlayer from './components/VideoPlayer';
import Accordion from './components/Accordion';
import FilterSlideIn from './components/FilterSlidein';
import ArticleFilter from './components/ArticleFilter';
import PublicationsFilter from './components/PublicationsFilter';
import SearchFilter from './components/SearchFilter';
import OfficesSearch from './vue/OfficesSearch.vue';
import ZNForms from './components/ZNforms';
import GaTrackApply from './components/GaTrackApply';
import TestimonialSlider from './components/TestimonialSlider';
import VideoCarousel from './components/VideoCarousel';
import CarouselSlider from './components/CarouselSlider';

export class Alfred {
	constructor() {
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));
		new Menu();
		new Accordion();
		new MenuBackground();
		new GaTrackApply();
		ResponsiveVideo.init();
		VideoPlayer.init();

		// initialize slider
		document.querySelectorAll('[data-slider]').forEach((elm) => {
			new Slider(elm);
		});

		document.querySelectorAll('[data-testimonial-slider]').forEach((elm) => {
			new TestimonialSlider(elm);
		});

		document.querySelectorAll('[data-carousel-slider]').forEach((elm) => {
			new CarouselSlider(elm);
		});

		document.querySelectorAll('[data-video-carousel-slider]').forEach((elm) => {
			new VideoCarousel(elm);
		});

		document.querySelectorAll('[data-zn-forms]').forEach((el) => new ZNForms(el));

		const $filterMenu = document.querySelector('[data-filter-menu]');
		if ($filterMenu) {
			new FilterSlideIn($filterMenu);
		}

		const $articlefilter = document.querySelector('[data-articlefilter]');
		if ($articlefilter) {
			new ArticleFilter($articlefilter);
		}

		const $publicationsfilter = document.querySelector('[data-publicationsfilter]');
		if ($publicationsfilter) {
			new PublicationsFilter($publicationsfilter);
		}

		const $searchfilter = document.querySelector('[data-searchfilter]');
		if ($searchfilter) {
			new SearchFilter($searchfilter);
		}

		const searchElements = document.querySelector('#vue-search-cards');

		if (searchElements) {
			const app = createApp(OfficesSearch, {
				cards: window.cards,
			});

			app.mount(searchElements);
		}

		// initialize readmore button
		const showMoreContainer = document.querySelector('[data-show-more]');
		const showMoreHolder = document.querySelector('[data-show-more-holder]');
		const showMoreButton = document.querySelector('[data-show-more-button]');

		if (!showMoreButton) {
			return;
		}

		showMoreButton.addEventListener('click', () => {
			showMoreContainer.classList.toggle('is-extended');

			if (showMoreContainer.classList.contains('is-extended')) {
				showMoreHolder.style.height = showMoreHolder.scrollHeight + 150 + 'px';
				showMoreButton.innerHTML = 'toon minder';

				showMoreButton.setAttribute('aria-expanded', true);
			} else {
				showMoreHolder.style.height = 350 + 'px';
				showMoreButton.innerHTML = 'Lees meer';
				showMoreButton.setAttribute('aria-expanded', false);
			}
		});
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();
